import styled, { css } from 'styled-components';
import { NotifyIcon } from 'web-components';
import Breadcrumbs from '../../../components/elements/Breadcrumbs';

export const Wrapper = styled.div(
  ({ theme, type }) => `
  ${theme.breakpoints.down('sm')} {
    margin-top: 5.5rem;
  }

  ${theme.breakpoints.down('xs')} {
    margin-top: 8.5rem;
  }
  
  ${
    type === 'sidebar' &&
    css`
      min-width: 250px;
      margin-top: 25px;
      margin-left: 15px;
    `
  }
  
  ${
    type === 'sidebar-collapse' &&
    css`
      max-width: 50px;
      margin-top: 25px;
      margin-left: 15px;
    `
  }
  `
);

export const TabsWrapper = styled.div`
  background-color: #367d78;
  border-radius: 0 15px 0 0;

  .MuiTab-wrapper {
    align-items: self-start;
    justify-content: flex-start;
  }
`;

export const SidebarCollapseItem = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 0;
`;

export const SidebarCollapseItemIcon = styled(NotifyIcon)`
  margin-right: 0.5rem;
  color: #e5f1f0;
  background-color: #87b1ae;
  border-radius: 50%;

  &:hover {
    background-color: #7bb8b4;
    transition: 250ms;
  }
`;

export const ContainerMachine = styled.div`
  display: flex;
`;

export const ContainerCustomerDetails = styled.div`
  display: flex;
`;

export const TabsWrapperCollapse = styled.div`
  background-color: #367d78;
  border-radius: 0 15px 0 0;

  .MuiTab-wrapper {
    align-items: self-start;
    justify-content: flex-start;
    width: 50px !important;
  }
`;

export const CustomerBreadcrumb = styled(Breadcrumbs)`
  margin-bottom: 30px;
  padding-left: 24px;
  font-size: 16px;

  .MuiTypography-h4 {
    font-size: 18px;
  }
`;

export const CustomerPageHeader = styled.div`
  padding-left: 0px;
  margin-bottom: 35px;
`;

export const StyledContentWrapper = styled.div`
  padding: 2rem 0 0;
`;
